import { Box, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import React, { useContext, useEffect } from "react";
import { ProcessContext } from "../../../../../../../../contexts/ProcessContext";
import { useEurobits } from "./hooks/useEurobits";

export function Eurobits() {
  const {
    state: { bankReaderWidgetUrl },
  } = useContext(ProcessContext);

  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));
  const { onSuccess, onError, getBankReaderWidgetUrl } = useEurobits();

  useEffect(() => {
    getBankReaderWidgetUrl();
  }, []);

  const eventMethod = window.addEventListener
    ? "addEventListener"
    : "attachEvent";
  const eventer = window[eventMethod];
  const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

  eventer(messageEvent, (e) => onBankReaderEvent(e));

  const onBankReaderEvent = (e) => {
    if (e.data.msg === "bankReaderWidget:ok") {
      onSuccess(e.data.iban);
    }
    if (e.data.msg === "bankReaderWidget:cancel") {
      onError();
    }
  };

  const frame = (bankReaderWidgetUrl) => {
    return {
      __html: `<iframe  
        aria-label={'Eurobits bank reader widget'}  
        src=${bankReaderWidgetUrl}
        id='bank'
        name='bank'
        frameBorder='0'
        height='100%'
        width="100%"
        />`,
    };
  };

  return (
    <Box
      px={0}
      py={isScreenXs ? 2 : 4}
      style={{ flex: "1 1 auto", overflow: "hidden", height: 400 }}
    >
      {bankReaderWidgetUrl && (
        <div
          style={{ borderRadius: "4px", overflow: "hidden", height: "100%" }}
          dangerouslySetInnerHTML={frame(bankReaderWidgetUrl)}
        />
      )}
    </Box>
  );
}
